import React, {Component} from 'react';

class InputRadio extends Component {
    constructor(props) {
        super(props);
        this.state = {checked: props.checked};
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {checked} = this.props;
        if (prevState.checked !== checked) {
            this.setState({checked});
        }
    }

    onChange(value) {
        this.props.onChange(value);
    }

    render() {
        const {className = '', value, label, inline} = this.props;
        const basicClass = inline ? 'radio-inline' : 'radio';

        const input = (
            <input
                type="radio"
                value={value}
                className={className}
                checked={this.state.checked}
                onChange={(() => this.onChange(value)).bind(this)}
            />
        );

        if (!label) {
            return input;
        }

        return (
            <div className={`${basicClass} ${className}`}>
                <label>
                    {input}
                    {label}
                </label>
            </div>
        );
    }
}

export default InputRadio;
